module.exports = __webpack_public_path__ + "media/images/favicon-16x16-08fba83f484d087d4fcbfd10653dfe27.png";